/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Cargo_FirstInputs */

const en_select_cargo_first = /** @type {(inputs: Select_Cargo_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a cargo`)
};

const es_select_cargo_first = /** @type {(inputs: Select_Cargo_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primero selecciona una carga`)
};

/**
* | output |
* | --- |
* | "Please select a cargo" |
*
* @param {Select_Cargo_FirstInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_cargo_first = /** @type {((inputs?: Select_Cargo_FirstInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Cargo_FirstInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_cargo_first(inputs)
	return es_select_cargo_first(inputs)
});